// WebAuthn (passkey) client — the single swap point between the local
// stub and the real @simplewebauthn/browser library.
//
// Currently re-exports from `webauthn-stub.js` because the real package
// isn't installed in the deploy environment yet. When it lands via
// `cd frontend && yarn add @simplewebauthn/browser@^11.0.0`, change the
// export block below to point at `@simplewebauthn/browser` (see the
// commented block at the bottom of this file) and passkeys light up
// everywhere.
//
// Consumers (LoginPage, ProfilePage) import from `'../lib/webauthn'` —
// they don't need to know which implementation is behind it. This wrapper
// stays the same file, in the same place, either way.

export {
  startAuthentication,
  startRegistration,
  browserSupportsWebAuthnAutofill,
} from '@simplewebauthn/browser';
export const isPasskeyClientAvailable = () => true;
